// Single source of truth for the frontend admin gate.
// The backend keeps a separate billing-bypass list in tempo-api auth.py
// (ADMIN_EMAILS) — changes to admin identities must update both lists.
export const ADMIN_EMAILS = [
  "edoardo@echonour.com",
  "edoardo.tribulato@hotmail.com",
  // Dedicated admin-QA account used by Anne for admin-gated QA.
  "anne-test@echonour.com",
];
